"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTableCheckAllButton = void 0;
var util_1 = require("@aperza/util");
var react_1 = __importDefault(require("react"));
var AcButton_1 = require("../button/AcButton");
var FaIcon_1 = require("../util/FaIcon");
var AcTableCheckAllButton = function (_a) {
    var _b = _a.selectedRowCount, selectedRowCount = _b === void 0 ? 0 : _b, onClick = _a.onClick;
    return (react_1.default.createElement(AcButton_1.AcButton, { className: "pl-1", variant: "sub2", size: "sm", active: selectedRowCount > 0, onClick: onClick },
        selectedRowCount === 0 && (react_1.default.createElement("div", { className: "d-flex align-items-center" },
            react_1.default.createElement(FaIcon_1.FaIcon, { icon: "far fa-check", size: "default", variant: "apzashblue", className: "mr-1", fixedWidth: true }),
            react_1.default.createElement("span", { className: "fs-small" }, "\u3059\u3079\u3066\u3092\u9078\u629E"))),
        selectedRowCount > 0 && (react_1.default.createElement("div", { className: "d-flex align-items-center" },
            react_1.default.createElement("span", { className: "position-relative mr-2" },
                react_1.default.createElement(FaIcon_1.FaIcon, { icon: "far fa-check", size: "default", variant: "primary", fixedWidth: true }),
                react_1.default.createElement("i", { className: "fas fa-circle text-attention position-absolute", style: { top: '0px', right: '-4px', fontSize: 4 } })),
            react_1.default.createElement("span", { className: "fs-small text-primary" },
                "\u3059\u3079\u3066(",
                util_1.NumberUtil.formattedNumber(selectedRowCount),
                "\u4EF6)\u3092\u9078\u629E\u4E2D")))));
};
exports.AcTableCheckAllButton = AcTableCheckAllButton;
exports.AcTableCheckAllButton.displayName = 'AcTableCheckAllButton';
//# sourceMappingURL=AcTableCheckAllButton.js.map